import React from 'react';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Palette, Brush, Image, Sparkles } from 'lucide-react';

const Arts = () => {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0a0a1e 0%, #1a0a2e 100%)',
      padding: '2rem',
      color: '#fff'
    }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h1 style={{
            fontSize: '3rem',
            background: 'linear-gradient(135deg, #ff6b6b, #ffa500)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            marginBottom: '1rem',
            fontWeight: 'bold'
          }}>
            Art Creation Studio
          </h1>
          <p style={{ color: '#888', fontSize: '1.1rem', maxWidth: '800px', margin: '0 auto' }}>
            AI-assisted digital art, image generation, and creative visual design
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '1.5rem',
          marginBottom: '3rem'
        }}>
          <Card style={{
            padding: '1.5rem',
            background: 'rgba(255, 107, 107, 0.1)',
            border: '1px solid rgba(255, 107, 107, 0.3)'
          }}>
            <Palette size={32} style={{ color: '#ff6b6b', marginBottom: '1rem' }} />
            <h3 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>Digital Painting</h3>
            <p style={{ color: '#888' }}>Create artwork with AI-assisted brushes</p>
          </Card>

          <Card style={{
            padding: '1.5rem',
            background: 'rgba(255, 165, 0, 0.1)',
            border: '1px solid rgba(255, 165, 0, 0.3)'
          }}>
            <Image size={32} style={{ color: '#ffa500', marginBottom: '1rem' }} />
            <h3 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>Image Generation</h3>
            <p style={{ color: '#888' }}>AI-powered image creation from text</p>
          </Card>

          <Card style={{
            padding: '1.5rem',
            background: 'rgba(138, 43, 226, 0.1)',
            border: '1px solid rgba(138, 43, 226, 0.3)'
          }}>
            <Sparkles size={32} style={{ color: '#8a2be2', marginBottom: '1rem' }} />
            <h3 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>Style Transfer</h3>
            <p style={{ color: '#888' }}>Apply artistic styles to images</p>
          </Card>
        </div>

        <Card style={{
          padding: '2rem',
          background: 'rgba(10, 10, 30, 0.8)',
          border: '1px solid rgba(255, 107, 107, 0.3)',
          marginBottom: '2rem'
        }}>
          <h2 style={{ fontSize: '1.5rem', color: '#ff6b6b', marginBottom: '1.5rem' }}>Art Creation Tools</h2>
          <div style={{ color: '#888', lineHeight: '1.8' }}>
            <p>Professional digital art widgets:</p>
            <ul style={{ marginTop: '1rem', paddingLeft: '2rem' }}>
              <li>AI Image Generator (Text-to-Image)</li>
              <li>Digital Canvas & Drawing Tools</li>
              <li>Photo Editor & Enhancement</li>
              <li>Style Transfer & Artistic Filters</li>
              <li>Color Palette Generator</li>
              <li>3D Model Viewer (Coming Soon)</li>
            </ul>
          </div>
        </Card>

        <Card style={{
          padding: '2rem',
          background: 'linear-gradient(135deg, rgba(255,107,107,0.1), rgba(255,165,0,0.1))',
          border: '2px solid #ff6b6b'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
            <Brush size={32} style={{ color: '#ff6b6b' }} />
            <h2 style={{ fontSize: '1.5rem', color: '#ff6b6b' }}>Art AI Advisor</h2>
          </div>
          <p style={{ color: '#ccc', marginBottom: '1.5rem' }}>
            Get creative art guidance from AI artists and designers. Ask about composition, color theory, 
            design principles, or any art-related question.
          </p>
          <Button style={{
            background: 'linear-gradient(135deg, #ff6b6b, #ffa500)',
            color: '#fff',
            fontWeight: 'bold',
            padding: '1rem 2rem'
          }}>
            Chat with Art AI
          </Button>
        </Card>
      </div>
    </div>
  );
};

export default Arts;